const swiper = new Swiper(".mobile-swiper", {
  autoplay: {
    delay: 2500,
  },
  effect: 'fade',
  speed: 1300,
  fadeEffect: {
    crossFade: true
  },
  // Optional parameters
  direction: "horizontal",
  loop: true,
  grabCursor: true,

  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  // And if we need scrollbar
  scrollbar: {
    el: ".swiper-scrollbar",
  },
});


const swiper2 = new Swiper(".pc-swiper", {
  autoplay: {
    delay: 2500,
  },
  effect: 'fade',
  speed: 800,
  fadeEffect: {
    crossFade: true
  },
  // Optional parameters
  direction: "horizontal",
  loop: true,
  grabCursor: true,

  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  // And if we need scrollbar
  scrollbar: {
    el: ".swiper-scrollbar",
  },
});